import { RecommendedColumnTitle } from "../../shared/types";

export const getFilteredColumns = (
  columns: RecommendedColumnTitle[],
  exclude: RecommendedColumnTitle[],
) => columns.filter(column => !exclude.includes(column));
